import { Helmet } from 'react-helmet-async';

export const SITE_URL = 'https://felix-genuss.ch';
export const SITE_NAME = 'Felix Genuss';
export const CONTACT_EMAIL = 'info@felix-genuss.ch';

export function Seo({ title, description, path = '/', image, jsonLd }) {
  const canonical = `${SITE_URL}${path === '/' ? '/' : path.replace(/\/$/, '')}`;
  const ogImage = image ? `${SITE_URL}${image}` : `${SITE_URL}/assets/brand/sternekueche-hero-1280.webp`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}

export function breadcrumbJsonLd(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.label,
      ...(item.href ? { item: `${SITE_URL}${item.href}` } : {}),
    })),
  };
}
